import axios, { AxiosResponse } from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { ICurrency } from 'safe'
import { CurrenciesTypes, SET_CURRENCIES } from './actionTypes'

const server = process.env.REACT_APP_SERVER_URL

const setCurrencies = (currencies: ICurrency[]): CurrenciesTypes => ({
  type: SET_CURRENCIES,
  payload: currencies,
})

export const fetchCurrencies =
  (): ThunkAction<Promise<void>, {}, {}, CurrenciesTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, CurrenciesTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        currencies: ICurrency[]
      }> = await axios.get(`${server}/finances/currency`)
      dispatch(setCurrencies(response?.data?.currencies))
    } catch (e) {
      throw e
    }
  }
